'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cloud-arrow-up';
var width = 576;
var height = 512;
var aliases = [62338,"cloud-upload","cloud-upload-alt"];
var unicode = 'f0ee';
var svgPathData = ['M32 336c0 61.9 50.1 112 112 112l304 0c53 0 96-43 96-96 0-41.8-26.8-77.5-64.2-90.6-4.3-1.5-7.8-4.8-9.5-9.1s-1.5-9 .5-13.1c5.9-11.8 9.2-25.1 9.2-39.2 0-48.6-39.4-88-88-88-13.6 0-26.4 3.1-37.9 8.5-7.2 3.5-15.9 1-20.3-5.7-20-30.6-54.6-50.8-93.8-50.8-61.9 0-112 50.1-112 112 0 10.6 1.5 20.9 4.2 30.5 1.2 4.3 .6 8.8-1.7 12.6s-6 6.5-10.3 7.4C69.8 237.4 32 282.3 32 336zm172.7-67.3l72-72c6.2-6.2 16.4-6.2 22.6 0l72 72c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L304 246.6 304 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-121.4-44.7 44.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z', 'M128 176c0-61.9 50.1-112 112-112 39.3 0 73.8 20.2 93.8 50.8 4.4 6.7 13.1 9.1 20.3 5.7 11.4-5.5 24.3-8.5 37.9-8.5 48.6 0 88 39.4 88 88 0 14.1-3.3 27.4-9.2 39.2-2 4.1-2.2 8.9-.5 13.1s5.2 7.6 9.5 9.1c37.4 13.1 64.2 48.8 64.2 90.6 0 53-43 96-96 96l-304 0c-61.9 0-112-50.1-112-112 0-53.7 37.8-98.6 88.2-109.5 4.3-.9 8.1-3.6 10.3-7.4s2.9-8.3 1.7-12.6c-2.7-9.7-4.2-19.9-4.2-30.5zM240 32c-79.5 0-144 64.5-144 144 0 8 .7 15.9 1.9 23.5-56.9 19.2-97.9 73-97.9 136.5 0 79.5 64.5 144 144 144l304 0c70.7 0 128-57.3 128-128 0-49.9-28.5-93-70.1-114.2 3.9-11.9 6.1-24.6 6.1-37.8 0-66.3-53.7-120-120-120-13.7 0-26.9 2.3-39.2 6.5-26.4-33.2-67.1-54.5-112.8-54.5zm59.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 246.6 272 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;